import {injectable} from "inversify";
import TeamFieldBasedCurrency from "@/modules/action-points/services/TeamFieldBasedCurrency";
import {GateTypeEnum} from "@/modules/action-points/enums";

@injectable()
export default class TrainingATActionPointsCurrency extends TeamFieldBasedCurrency {
  protected getFieldName(): 'actionPointsTrainingAT' {
    return 'actionPointsTrainingAT';
  }

  protected getType(): GateTypeEnum {
    return GateTypeEnum.TRAINING_AT;
  }
}
